import { useSessionClient, AccountButton } from "@latticexyz/entrykit/internal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { DoomContainer } from "./DoomContainer";
import { stash, tables } from "./stash";
import { getRecord } from "./getRecord";
import { useEffect, useMemo, useState } from "react";
import { useStash } from "@latticexyz/stash/react";
import { Explorer } from "./Explorer";

export const Arena = () => {
  const { data: client } = useSessionClient();

  const navigate = useNavigate();

  const matchConfig = useStash(stash, (state) => getRecord({ state, table: tables.MatchConfig, key: [] }));

  const currentMatch = useStash(stash, (state) => {
    const currentMatchId = getRecord({ state, table: tables.MatchCounter, key: [] })?.value;
    if (!currentMatchId) return undefined;
    return getRecord({ state, table: tables.Match, key: { id: currentMatchId } });
  });

  const isHost = useMemo(
    () => client && currentMatch && currentMatch.players[0] === client.account!.address,
    [currentMatch, client],
  );

  const isLoaded = useMemo(() => client && matchConfig, [matchConfig, client]);

  const isInMatch = useMemo(
    () => client && currentMatch && currentMatch.players.includes(client.account.address),
    [currentMatch, client],
  );

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (!isInMatch) {
      console.log("You are not in this match");
      navigate("/");
    }
  }, [client, currentMatch, navigate]);

  const [searchParams] = useSearchParams();
  const extension = searchParams.get("extension") ?? undefined;
  const map = searchParams.get("map") ?? "07";

  const [showExplorer, setShowExplorer] = useState(false);
  useEffect(() => {
    // Listen to keypress of "`"
    const onKeyPress = (event: KeyboardEvent) => {
      if (event.key === "`") {
        setShowExplorer((prev) => !prev);
      }
    };
    window.addEventListener("keydown", onKeyPress);
    return () => window.removeEventListener("keydown", onKeyPress);
  }, []);

  return (
    <div className="grid place-items-center content-center py-8 h-dvh w-full">
      <ErrorBoundary
        fallbackRender={({ error }) => {
          console.error(error);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
          return (
            <div>
              {"Something went wrong. Check the console for more information. Reloading the page in 5 seconds..."}
            </div>
          );
        }}
      >
        {!client ? (
          <AccountButton />
        ) : !isLoaded ? (
          "Loading..."
        ) : !isInMatch ? (
          "You are not part of this match, redirecting..."
        ) : (
          <DoomContainer
            client={client}
            isHost={isHost}
            map={map}
            extension={extension}
            matchId={currentMatch!.id}
            participants={currentMatch!.players.length}
          />
        )}
      </ErrorBoundary>
      {showExplorer && <Explorer />}
    </div>
  );
};
